import { Component, OnInit , AfterViewInit} from '@angular/core';
import {ActivatedRoute,Router} from "@angular/router";
import {DataService} from '../data.service';
import {environment} from '../../environments/environment.prod'
import {Meta,Title,SafeUrl,DomSanitizer} from '@angular/platform-browser';
import {HomeComponent} from '../home/home.component';
import {NavbarComponent} from '../navbar/navbar.component';
import {UserSearch} from '../models/user-search';


declare var $:any;

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit ,AfterViewInit{
  text:string="";
  userTypeId:number=-1;
  data:any[]=[];
  imgPath:string="";
  companyId:number=-1;
  userId:number=-1;
  arr=Array;
  moduleId:number=-1;
  type:string="";
  isLink:boolean=true;
  isShareMenu:boolean=false;
  shareUrl:string="";
  myurl:string="whatsapp://send?text=http://happcoach.com/PilotServices/Module/"+this.moduleId+".html";
  dataCount:number=1;
  planId:number=-1;
  isNext:boolean=false;
  textContent:string='';
  isLoading:boolean=false;
  userSearch:UserSearch;
  freeTag:boolean=false;

  constructor(
    private route:ActivatedRoute,
    private service:DataService,
    private router:Router,
    private title:Title,
    private meta:Meta,
    private sanitizer:DomSanitizer,
    private home:HomeComponent,
    private navbar:NavbarComponent,


  ) { }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"))
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.companyId=sessionStorage.getItem('companyId')==null ? -1  : parseInt(sessionStorage.getItem('companyId'));
    this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
   // console.log(`Company Id ${this.companyId}`);
    this.imgPath=environment.imagePath;
    this.route.params.subscribe((params)=>{
      this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"))
      this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.companyId=sessionStorage.getItem('companyId')==null ? -1  : parseInt(sessionStorage.getItem('companyId'));
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
      this.text=params['searched'].split('-').join(' ');
      // this.navbar.text=this.text.split('-').join(' ');
      this.isLoading=true;




    });


    this.userSearch=new UserSearch(this.userId,this.companyId,this.text,this.service,this.router);
    this.userSearch.Search=this.userSearch;
    this.userSearch.getSearchModule();
    this.data=this.userSearch.Data;


     // console.log(this.data);
      setTimeout(()=>{
        this.isLoading=false;
        if(this.data.length==0){
          this.textContent="No search results found";
        }
      },1500)




   //    this.navbar.searchResultsUpdated.subscribe(
   //   (search) => {
   //
   //   }
   // );
   this.service.watchSearchSub().subscribe((data)=>{
     this.textContent='';
  this.isLoading=false;
  this.data=UserSearch.getData();


    setTimeout(()=>{
      this.isLoading=false;
      if(this.data.length==0){
        this.textContent="No search results found";
      }
    },1500)



   })
  }




  ngAfterViewInit(){
    $(window).scrollTop(0);
    // $('.cd-primary-nav-trigger').click(function(){
    //   if($('.cd-primary-nav').hasClass('is-visible')){
    //
    //     $('app-search-results').css('filter','blur(5px)');
    //   } else {
    //     $('app-search-results').css('filter','blur(0px)');
    //   }
    // })
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  showShareOptions(pvarId,pvarType){
   // console.log(pvarId);
    if(this.moduleId==pvarId){
        this.isShareMenu=!this.isShareMenu;
    }
    else {
        this.isShareMenu=true;
    }
    this.moduleId=pvarId;
    this.type=pvarType;

    this.updateMeta();
  }

  hideShareOptions(pvarId){
    if(this.moduleId==pvarId)
    this.isShareMenu=false;
  }

  goToModule(pvarId,pvarName,isLink,pvarIsFree){
    if(isLink==true){

      if(this.userId!=-1){
      if(localStorage.getItem("planId")=='-1' && pvarIsFree==false){
        const inputJson={
          "ModuleId":pvarId,
          "UserId":this.userId
        }
       // console.log(inputJson);
        this.service.ClickOnPaidModule(inputJson)
        .subscribe(
          (result:any[])=>{
           // console.log(result);
            if(result['Status']=="Success"){

            }
            else{
              this.service.alert(result['Message'],"error");
            }
          },
          (error:Error)=>{
           // console.log(error);
          }
        )

      }

    }

      var name=pvarName.split(' ').join('-');
      this.router.navigate(['module',name,pvarId]);

    } else {
      return false;
    }
  }

  addBookmark(pvarId,status) {
    if(this.userId==-1){
      this.service.alert("Please login to use this feature","error");
      return false;
    } else {
      const inputJson = {
          "ModuleId":pvarId,
          "Status":status,
          "UserId":this.userId
      }

      if(status=="False"){
        inputJson.Status=true
      }
      else if(status=="True"){
        inputJson.Status=false
      }
       // console.log(inputJson);
        this.service.AddBookmark(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              if(inputJson.Status==true)
              this.service.alert("Bookmark added successfully","success");
              else
              this.service.alert("Bookmark removed successfully","success");

            } else {
              this.service.alert(result['Message'],"error");
            }

          },
          (error)=>{
           // console.log(error);
          },
          ()=>{

            this.data=[];
            setTimeout(()=>{

              this.ngOnInit();
            },1000)


          }
        )
    }

  }
  // Harkamal Singh : Method to update meta tag
  updateMeta(){
    this.meta.updateTag({
content: 'http://happcoach.com/PilotServices/Module/'+this.moduleId+'.html'
},
"property='og:url'"
);
  this.shareUrl="https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
  // this.shareUrl="http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

  }
  // Harkamal Singh : Method to share to facebook,twitter,linkedin,g+
    shareToSocial(pvarChoice:number){
      if(pvarChoice==0){ // facebook
          window.open(
            "http://www.facebook.com/sharer/sharer.php?u="+this.shareUrl,
            '_blank' // <- This is what makes it open in a new window.
          );
      }

      if(pvarChoice==1){//twitter
        window.open(
        "https://twitter.com/intent/tweet?url="+this.shareUrl+"&text="+this.title.getTitle(),
        '_blank'
      );
    }
      if(pvarChoice==2){//linkedin
        window.open(
        "https://www.linkedin.com/shareArticle?mini=true&url="+this.shareUrl+"&title="+this.title.getTitle(),
        '_blank'
      )
      }

      if(pvarChoice==3){//google plus
        window.open(
        "https://plus.google.com/share?url="+this.shareUrl,
        '_blank'
      )
      }

    }

    getNumber(rating){
      return Math.trunc(rating);
    }

    sanitize(){
      let url:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
      // let url:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

      this.myurl=url;
       let s:SafeUrl=this.sanitizer.bypassSecurityTrustUrl(this.myurl);
       return s;
    }
 shareWhatsApp(){
       window.location.href = "whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
       // window.location.href = "whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

     }

     showActiveModule(pvarId){
       this.home.showActiveModule(pvarId);
     }

     freeActive(){
       this.freeTag=true;
       this.isLink=false;
     }

     freeInactive(){
       this.freeTag=false;
       this.isLink=true;
     }


}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/search-results/search-results.component.ts